import React from "react";
import { ROLES, fmtAgo } from "../api";
import { useUI } from "../UIContext";
import { useAuth } from "../AuthContext";

const HEALTH_LABEL = { healthy: "Plant Healthy", warning: "Opportunity Detected", critical: "Major Deviation" };

export default function Header({ state }) {
  const { role, setRole } = useUI();
  const { authEnabled, logout } = useAuth();
  const mode = state?.mode || "simulated";
  const health = state?.health || "muted";
  const last = state?.last_update;

  return (
    <header className="oim-header" data-testid="header">
      <div className="header-left">
        <div>
          <div className="header-title">AARTI INDUSTRIES — JHAGADIA</div>
          <div className="header-sub">Aniline + Nitrobenzene · 200 TPD nameplate</div>
        </div>
      </div>
      <div className="header-right">
        <span className="pill live" data-testid="mode-pill">
          <span className="dot" /> {mode === "simulated" ? "Simulation Mode" : "Live Mode"}
        </span>
        <span className="pill" data-testid="last-update">
          Updated {fmtAgo(last)}
        </span>
        <span className={`pill ${health}`} data-testid="health-pill">
          <span className="dot" /> {HEALTH_LABEL[health] || health.toUpperCase()}
        </span>
        <select
          className="role-select"
          value={role}
          onChange={e => setRole(e.target.value)}
          data-testid="role-switcher"
          aria-label="Role"
        >
          {ROLES.map(r => <option key={r.key} value={r.key}>{r.label}</option>)}
        </select>
        {authEnabled && (
          <button className="btn" onClick={logout} data-testid="logout-button">
            Sign Out
          </button>
        )}
      </div>
    </header>
  );
}
